/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-sales-tab-container',
  templateUrl: 'sales-tab-container.component.html',
  styleUrls: ['sales-tab-container.component.scss'],
})
export class SalesTabContainerComponent {
}
